import { useEntityLinkVerdict } from "~/ai-chat/data-source/use-entity-link-verdict";
import { ChatEntityChip, type ChatEntityChipProps } from "~/ai-chat/ui/chat-entity-chip";

// The chip the transcript renders for an assistant-emitted link: the LLM can hallucinate an
// id, so the link stays inert until the backend confirms the object exists.
export function ChatVerifiedEntityChip(props: ChatEntityChipProps) {
  const verdict = useEntityLinkVerdict(props.link);
  return <ChatEntityChip {...props} verdict={verdict} />;
}
